import { scrollTracker } from "./utilities/scrollTracker"
import { masthead } from "./blocks/masthead"
import { team } from "./blocks/team"
import { gsapAnimations } from "./blocks/gsapAnimations"
import { choicesJS } from "./utilities/choices"
import { alignFull } from "./utilities/alignFull"
import { wpColumns } from "./blocks/wp-columns"
import { initPeopleAjax, initInvestmentsAjax, initPostsAjax } from "./utilities/ajax"
import { navigation } from "./utilities/navigation"
import { wpBlockSocialIcons } from "./blocks/wp-block-social-icons"
import { lottieAnimations } from "./blocks/lottie"
import { vimeoVideos } from "./utilities/vimeoVideos"
import { timeline } from "./blocks/timeline"
import { navPrices } from "./blocks/nav-prices"
import { locationsMap } from "./blocks/locationsMap"
import { hero } from "./blocks/hero"
import { scrollObserver } from "./utilities/scrollObserver"
import { notice } from "./utilities/notice"
import { wpBlockGroup } from "./blocks/wp-block-group"
import { accordion } from "./blocks/accordions"
import { wpBlockTable } from "./blocks/wp-block-table"
import { stats } from "./blocks/stats"
import { kidsTable } from "./blocks/kidsTable"

document.addEventListener("DOMContentLoaded", () => {
  scrollTracker();
  masthead();
  gsapAnimations();
  wpColumns();
  choicesJS();
  alignFull();
  initPeopleAjax();
  initInvestmentsAjax();
  initPostsAjax();
  navigation();
  wpBlockSocialIcons();
  lottieAnimations();
  vimeoVideos();
  timeline();
  team();
  navPrices();
  locationsMap();
  hero();
  scrollObserver(); // Initialize scroll observer for InView animations
  notice();
  wpBlockGroup();
  wpBlockTable();
  accordion();
  kidsTable();
});


